document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll('.control-offer-list .offer-destination-filter input[type="radio"]').forEach((input) => {
        input.addEventListener('change', function () {
            const selectedValue = this.value;
            const offerCards = document.querySelectorAll('.control-offer-list .offer-card');

            offerCards.forEach((card) => {
                const destinations = card.dataset.offerDestination.split(",");
                if (selectedValue === "" || destinations.includes(selectedValue)) {
                    card.classList.remove("hidden-card");
                } else {
                    card.classList.add("hidden-card");
                }
            });
        });
    });
});
